import React from 'react';
import {FlatList} from 'react-native';
import {withForwardedNavigationParams} from 'react-navigation-props-mapper';
import ScreenContext from '../../ScreenContext';
import withIsConnected from '../../hoc/withIsConnected';
import BaseScreen from '../BaseScreen';
import type {GiftItem as GiftItemType} from 'src/types/Snack';
import GiftItem from '../../elements/sendSnack/GiftItem';
import ActionsFactory from 'src/actions/ActionsFactory';
import Util from 'src/Util';
import AccountStore from 'src/stores/AccountStore';
import moment from 'moment';
import Localized from 'src/constants/AppStrings';

type GiftFeedScreenProps = Record<string, never>;
type GiftFeedScreenState = {
  isRefreshing: boolean;
  giftItems: Array<GiftItemType>;
  offset: number;
};

class GiftFeedScreen extends React.Component<
  GiftFeedScreenProps,
  GiftFeedScreenState
> {
  static contextType = ScreenContext;
  started = null;

  constructor(props: GiftFeedScreenProps) {
    super(props);
    this._onChange = this._onChange.bind(this);
    this.renderGiftItem = this.renderGiftItem.bind(this);
    this.handleLoadMore = this.handleLoadMore.bind(this);
    this.getKeyForListItem = this.getKeyForListItem.bind(this);
    this._onRefresh = this._onRefresh.bind(this);
    const giftItems = AccountStore.getGiftFeedList();
    this.state = {
      isRefreshing: false,
      giftItems: giftItems,
      offset: 0,
    };
  }

  componentDidMount() {
    AccountStore.addGiftFeedChangedListener(this._onChange);
  }

  componentWillUnmount() {
    AccountStore.removeGiftFeedChangedListener(this._onChange);
  }

  async _onChange() {
    await Util.delayForUX(this.started);
    this.setState({
      isRefreshing: false,
      giftItems: AccountStore.getGiftFeedList(),
    });
  }

  _onRefresh(offset: number) {
    this.started = moment();
    ActionsFactory.getAccountActions().loadGiftFeed(
      AccountStore.getLocationId(),
      offset,
    );
    this.setState({
      isRefreshing: true,
      offset,
    });
  }

  handleLoadMore() {
    const fullItems = AccountStore.getGiftFeedList();
    const lastItem = fullItems[fullItems.length - 1];
    const hasMore = !lastItem.lastItem;

    if (hasMore && !this.state.isRefreshing) {
      this._onRefresh(this.state.offset + 10);
    }
  }

  getKeyForListItem(item) {
    return item.snackId;
  }

  renderGiftItem({item}) {
    return <GiftItem key={item.snackId} gift={item} />;
  }

  render() {
    return (
      <BaseScreen title={Localized.Labels.gift_feed_title}>
        <FlatList
          refreshing={this.state.isRefreshing}
          onRefresh={() => this._onRefresh(0)}
          data={this.state.giftItems}
          renderItem={this.renderGiftItem}
          keyExtractor={this.getKeyForListItem}
          onEndReached={this.handleLoadMore}
        />
      </BaseScreen>
    );
  }
}

export default withForwardedNavigationParams()(withIsConnected(GiftFeedScreen));
